import { render, staticRenderFns } from "./praviteAgreement.vue?vue&type=template&id=8a2e0fc2&scoped=true&"
import script from "./praviteAgreement.vue?vue&type=script&lang=js&"
export * from "./praviteAgreement.vue?vue&type=script&lang=js&"
import style0 from "./praviteAgreement.vue?vue&type=style&index=0&id=8a2e0fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2e0fc2",
  null
  
)

export default component.exports